module.exports = __webpack_public_path__ + "img/wallet4good.a4c1bd8e.svg";